interface IntroSlideTextSliderProp {
  data: {
    Title?: string;
    id: number;
  }[];
}

const IntroSlideTextSlider: React.FC<IntroSlideTextSliderProp> = ({ data }) => {
  const title = data.find((item) => item.Title?.trim())?.Title;

  if (!title) return null;

  return (
    <span className="intro-slide-text__slider">
      {title}
    </span>
  );
};

export default IntroSlideTextSlider;
